import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-customer-emails-editor',
    templateUrl: './customer-emails-editor.component.html',
    styleUrls: ['./customer-emails-editor.component.css']
})
export class CustomerEmailsEditorComponent {
    @Input() emails: string[] = [''];
    @Output() emailsChange = new EventEmitter<string[]>();

    trackByIndex(index: number): number {
        return index;
    }

    add(): void {
        this.emailsChange.emit(this.emails.concat(''));
    }

    remove(index: number): void {
        if (this.emails.length <= 1) {
            this.emailsChange.emit(['']);
            return;
        }
        this.emailsChange.emit(this.emails.filter((_, current) => current !== index));
    }
}
